// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","667":"3f3796ac","977":"a7e1381c"}[chunkId] + ".chunk.js";
};